__turbopack_context__.v({
  "button": "PzCeaG_button",
  "container": "PzCeaG_container",
  "text": "PzCeaG_text",
});
